import { Modal } from 'flowbite';
import type { ModalOptions, ModalInterface } from 'flowbite';

export default class bookModal{

    /**
     * Get Modal
     * @param el 
     * @param elClose 
     */
    get(el: string, elClose: string){

        const targetEl = document.getElementById(el);
        const targetClose = document.getElementById(elClose);
    
        const options: ModalOptions = {
            placement: 'top-center',
            backdrop: 'static',
            backdropClasses: 'bg-gray-900 bg-opacity-50 fixed inset-0 z-[60]'
        };
    
        /*
         * targetEl: required
         * options: optional
        */
        const modal: ModalInterface = new Modal(targetEl, options);
    
        modal.show();
        
        targetClose?.addEventListener("click", function(e){
            e.preventDefault();

            // Hide
            modal.hide();

            //  dDstroy and remove instance
            modal.destroyAndRemoveInstance();

            // Remove Element
            targetEl?.remove();

        });

    }

}